import {AssistantRunEvents} from "@/helper/chat/assistantRun/assistantRun";

import {AssistantRunConfig} from "@/helper/chat/assistantRun/assistantRunConfig";
import {AssistantRunStatus} from "@/helper/chat/assistantRun/assistantRunStatus";
import {Emitter} from "mitt";
import {fetchWithAuth} from "@/client";


export type AssistantRunEvent = 'requestStart' | 'cancelled' | 'responseStart' | 'responseEnd'

const consoleLog = true

export class AssistantRunEventTracker {
    private completionCounter = 0;

    constructor(
        private runConfig: AssistantRunConfig,
        private runId: string
    ) {}

    public async track (eventType: AssistantRunEvent) {
        if (eventType === 'requestStart') {
            this.completionCounter++;
        }

        if (consoleLog) {
            switch (eventType) {
                case 'requestStart':
                    console.time(this.runConfig.assistantType)
                    break;
                case 'responseStart':
                    console.timeLog(this.runConfig.assistantType, 'streaming...')
                    break;
                case "cancelled":
                case 'responseEnd':
                    console.timeEnd(this.runConfig.assistantType)
                    break
            }
        }

        const event = JSON.stringify({
            completionCounter: this.completionCounter,
            runId: this.runId,
            assistantType: this.runConfig.assistantType,
            eventType,
            timestamp: (new Date()).toISOString(),
        })

        fetchWithAuth(
            import.meta.env.VITE_REST_ENDPOINT + '/aines/track-event' + '?' + this.runConfig.assistantType,
            event,
            "POST"
        );
    }

}
